import React, { Component } from 'react'
import { connect } from 'react-redux'
import MonitorPage from 'components/MonitorPage'
import { joinMonitor } from 'actions/api/visits'
import ActionCableContainer from 'containers/ActionCableContainer'
import queryString from 'query-string'
import {isVisManager} from 'utils/visManager'

class MonitorContainer extends Component {
  render() {
    const {
      webrtcToken,
      roomName,
      inmateId,
      visitorId,
      joinMonitor,
      monitorJoinError,
      userTracks,
      isVideoWall,
      visitStatus,
      isSuspended,
      idToJoin
    } = this.props

    return (
      <div>
        <ActionCableContainer channelName='VisitNotificationsChannel' />
        <MonitorPage
          webrtcToken={webrtcToken}
          roomName={roomName}
          inmateId={inmateId}
          visitorId={visitorId}
          joinMonitor={joinMonitor}
          monitorJoinError={monitorJoinError}
          userTracks={userTracks}
          isVideoWall={isVideoWall}
          visitStatus={visitStatus}
          isSuspended={isSuspended}
          idToJoin={idToJoin}
        />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    roomName: state.visit.roomName,
    webrtcToken: state.visit.webrtcToken,
    conferenceId: state.visit.conferenceId,
    appointmentId: state.visit.appointmentId,
    inmateId: state.visit.inmateId,
    visitorId: state.visit.visitorId,
    monitorJoinError: state.visit.monitorJoinError,
    userTracks: state.userTracks,
    visitStatus: state.visit.visitStatus,
    isSuspended: state.visit.isSuspended
  }
}

function mapDispatchToProps (dispatch) {
  return {
    joinMonitor: (conferenceId, isVideoWall) => dispatch(joinMonitor(conferenceId, isVideoWall)),
    setVisitStatus: (status) => dispatch(setVisitStatus(status))
  }
}

function mergeProps (stateProps, dispatchProps, ownProps) {
  const isVideoWall = queryString.parse(ownProps.location.search.substr(1)).video_wall === 'true'
  const idToJoin = isVisManager() ? stateProps.appointmentId : stateProps.conferenceId

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    joinMonitor: () => dispatchProps.joinMonitor(idToJoin, isVideoWall),
    isVideoWall,
    idToJoin
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MonitorContainer)
